import React from 'react'
import { MdCheck } from 'react-icons/md'
import AppStore from '../../img/appstore_sv.png'
import GooglePlay from '../../img/googleplay_sv.png'
import SaEnkeltLogo from '../../img/sa-enkelt-logo.svg';
import CityLogo from '../../img/city-logo-2.svg';

const { REACT_APP_BRAND } = process.env;

const PrintFooter: React.FC = () => {
  const BrandLogo = REACT_APP_BRAND === 'CITY' ? CityLogo : SaEnkeltLogo;

  return (
    <div className="print-footer">
      <div className="footer-left">
        <img src={BrandLogo} alt="Brand Logo" className="brand-logo" />
        <div className="store-buttons">
          <img src={AppStore} alt="App Store" className="store-button" />
          <img src={GooglePlay} alt="Google Play" className="store-button" />
        </div>
      </div>
      <div className="footer-right">
        <div className="footer-check-item">
          <span className="checkbox">
            <MdCheck />
          </span>
          <span>Alltid i fickan</span>
        </div>
        <div className="footer-check-item">
          <span className="checkbox">
            <MdCheck />
          </span>
          <span>Dela med familjen</span>
        </div>
        <div className="footer-check-item">
          <span className="checkbox">
            <MdCheck />
          </span>
          <span>Spara tusenlappar</span>
        </div>
      </div>
    </div>
  )
}

export default PrintFooter;
